import { useEffect } from 'react';
import {
  HOME_ONBOARDING_REDIRECT,
  shouldRedirectHomeFromLanding,
} from '../../config/tempCrmPivot';

/** Sends `/` visitors straight to portal onboarding during the temp pivot. */
const HomeRedirect = () => {
  useEffect(() => {
    if (shouldRedirectHomeFromLanding()) {
      window.location.replace(HOME_ONBOARDING_REDIRECT);
    }
  }, []);
  return null;
};

export default HomeRedirect;
